<template>
  <el-card class="forms-containers" style="padding: 0px" shadow="never">
    <div class="apps-container">
      <public-table
        v-loading="listLoading"
        :column="column"
        :enableSearch="true"
        :searchItems="searchItems"
        :tableData="payments"
        :PageInfo="listQuery"
        @handlePaginationChange="getPaymentList"
      >
        <template v-slot:createTime="{ row }">
          {{ row.createTime ? timetrans(row.createTime) : '-' }}
        </template>
        <template v-slot:paymentType="{ row }">
          {{ showPaymentType(row.paymentType) }}
        </template>
        <template v-slot:price="{ row }">{{ row.price }} 元</template>
        <template v-slot:balance="{ row }">{{ row.balance }} 元</template>
      </public-table>
    </div>
  </el-card>
</template>
<script>
import { timetrans } from '@/utils/validate';
import { fetchPayments } from '@/api/myOrder';
import { errorHandle } from '../../../utils/error';
const defaultListQuery = {
  page: 1,
  size: 10
};

export default {
  name: 'Integral',
  components: {},
  data() {
    const orgOptions = [];
    this.$store.state.user.userOrgs.map((item) => {
      if (item) {
        orgOptions.push({
          label: item.name,
          value: item.orgID
        });
      }
    });
    const paymentOptions = [
      {
        label: '全部',
        value: ''
      },
      {
        label: '充值',
        value: 'recharge'
      },
      {
        label: '消费',
        value: 'consumption'
      },
      {
        label: '收入',
        value: 'income'
      }
    ];
    return {
      paymentOptions: paymentOptions,
      customerForm: {
        type: 'all'
      },
      searchItems: [
        {
          label: '组织机构',
          name: 'orgID',
          value: '',
          type: 'select',
          span: 8,
          options: orgOptions
        },
        {
          label: '交易编号',
          name: 'paymentID',
          value: '',
          span: 8,
          type: 'input'
        },
        {
          label: '订单号',
          name: 'orderID',
          value: '',
          span: 8,
          type: 'input'
        },
        {
          label: '交易时间',
          name: ['startTime', 'endTime'],
          type: 'timerange',
          span: 8,
          value: ''
        },
        {
          label: '收支类型',
          name: 'paymentType',
          value: '',
          span: 8,
          type: 'select',
          options: paymentOptions
        }
      ],
      listQuery: Object.assign({}, defaultListQuery),
      payments: [],
      listLoading: true,
      timetrans: timetrans,
      editCustomer: {},
      showEditCustomer: false,
      column: [
        {
          prop: 'paymentID',
          label: '交易编号',
          fixed: 'left',
          width: '250px'
        },
        {
          prop: 'createTime',
          label: '交易时间',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'paymentType',
          label: '收支类型',
          width: '100px',
          scopeStatus: true
        },
        {
          prop: 'orderID',
          width: '165px',
          label: '订单号'
        },
        {
          prop: 'payer',
          label: '付款人'
        },
        {
          prop: 'payerOrg',
          label: '付款组织'
        },
        {
          prop: 'price',
          label: '金额',
          scopeStatus: true
        },
        {
          prop: 'balance',
          label: '余额',
          scopeStatus: true
        },
        {
          prop: 'note',
          width: '220px',
          label: '备注'
        }
      ]
    };
  },
  created() {
    this.getPaymentList();
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    sidebar() {
      return this.$store.state;
    }
  },
  methods: {
    showPaymentType(t) {
      let show = t;
      this.paymentOptions.map((item) => {
        if (item.value == t) {
          show = item.label;
        }
      });
      return show;
    },
    getPaymentList(param) {
      this.listLoading = true;
      if (param) {
        this.listQuery = Object.assign(this.listQuery, param);
      }
      fetchPayments(this.listQuery)
        .then((re) => {
          this.payments = re.payments;
          this.listQuery.total = re.total;
          this.listLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.listLoading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/information/integral/index.vue